module.exports = __webpack_public_path__ + "img/luchetti.e975f36a.jpeg";